/**
 * Created by chandan on 1/30/2023.
 */
export const HO_GET_HAND_OFF_USERS = 'HO_GET_HAND_OFF_USERS';
export const HO_GET_HAND_OFF_USERS_ID = 'HO_GET_HAND_OFF_USERS_ID';

// Tasklist - bulk handoff
// export const GET_HAND_OFF_TASKS = 'GET_HAND_OFF_TASKS';
// export const CLEAR_HAND_OFF_TASKS = 'CLEAR_HAND_OFF_TASKS';

// Task documents	
export const HO_GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY = 'HO_GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY';
export const HO_CLEAR_HANDSOFF_TASK_DOCUMENTS = 'HO_CLEAR_HANDSOFF_TASK_DOCUMENTS';
export const HO_GET_EVIDENCES = 'HO_GET_EVIDENCES';
export const HO_UPDATE_SIGNOFF_GIVEN_DOCUMENTS = 'HO_UPDATE_SIGNOFF_GIVEN_DOCUMENTS';
export const HO_UPDATE_SIGNOFF_INDIVIDUAL_DOCUMENT = 'HO_UPDATE_SIGNOFF_INDIVIDUAL_DOCUMENT';

// Task reviewer
export const HO_GET_STATUS_ASSIGNMENTS = 'HO_GET_STATUS_ASSIGNMENTS';

// Task details
export const HO_GET_TASK_DETAILS = 'HO_GET_TASK_DETAILS';
export const HO_APPLY_SIGNOFF_AND_CHANGE_TASK_STATUS = 'HO_APPLY_SIGNOFF_AND_CHANGE_TASK_STATUS';

// Create Assignments
export const HO_CREATE_TASK_ASSIGNMENT = 'HO_CREATE_TASK_ASSIGNMENT';
export const HO_EDIT_TASK_ASSIGNMENTS = 'HO_EDIT_TASK_ASSIGNMENTS';
export const HO_GET_ASSIGNMENTS = 'HO_GET_ASSIGNMENTS';
export const HO_CREATE_ASSIGNMENTS = 'HO_CREATE_ASSIGNMENTS';
export const HO_CLEAR_ERRORS = 'HO_CLEAR_ERRORS';
export const HO_GET_MANAGE_ASSIGNMENTS = 'HO_GET_MANAGE_ASSIGNMENTS';


